import { render, staticRenderFns } from "./QuicksightDashboard.vue?vue&type=template&id=c9404370&scoped=true&"
import script from "./QuicksightDashboard.vue?vue&type=script&lang=ts&"
export * from "./QuicksightDashboard.vue?vue&type=script&lang=ts&"
import style0 from "./QuicksightDashboard.vue?vue&type=style&index=0&id=c9404370&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9404370",
  null
  
)

export default component.exports